import React from "react";
import "../../index.css";
import "./LocationComponent.css";
import {
  EnvironmentFilled,
  PhoneFilled,
  ClockCircleFilled,
} from "@ant-design/icons";

const LocationComponent = ({
  title,
  address,
  postCode,
  email,
  mapSrc,
  mapTitle,
}) => {
  return (
    <div className="container location-container">
      <div className="text-location-container">
        <h1 className="title">{title}</h1>
        <p className="subtitle location-subtitle">
          {address} - {postCode}
          {email ? <p>Email: {email}</p> : <p />}
        </p>
      </div>
      <div className="maps-location">
        <iframe
          title={mapTitle}
          src={mapSrc}
          style={{ width: "100%", border: "none", height: "50vh" }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

const StoreLocationComponent = ({
  title,
  address,
  postCode,
  schedules = [],
  photos = [],
  telp,
  mapSrc,
  mapTitle,
  inverted,
}) => {
  const bigPhoto = photos.find((p) => p.isBig);
  const smallPhotos = photos.filter((p) => !p.isBig);
  console.log(photos);

  return (
    <div
      className={`container store-location-container ${
        inverted ? "inverted" : ""
      }`}
    >
      <div className="photo-container">
        {bigPhoto && (
          <div className="big-photo">
            <img src={bigPhoto.src} alt={bigPhoto.alt} />
          </div>
        )}
        <div className="small-photo">
          {smallPhotos.map((small, index) => (
            <div className="small-img-wrapper" key={index}>
              <img src={small.src} alt={small.alt} />
            </div>
          ))}
        </div>
      </div>
      <div className="store-detail-container">
        <div className="text-location-container">
          <h1 className="title2">{title}</h1>
          <p className="subtitle store-location-subtitle">
            <p
              style={{
                display: "flex",
                textAlign: "justify",
                gap: "20px",
              }}
            >
              <EnvironmentFilled />
              {address} - {postCode}
            </p>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <ClockCircleFilled style={{ marginTop: 4 }} />
              <div
                style={{ display: "flex", flexDirection: "column", gap: "4px" }}
              >
                {schedules.map((s, index) => (
                  <div key={index} style={{ display: "flex", gap: "20px" }}>
                    <span>
                      {s.dayOpen}, {s.timeOpen}
                    </span>
                  </div>
                ))}
              </div>
            </div>
            {telp ? (
              <p
                style={{
                  display: "flex",
                  textAlign: "justify",
                  gap: "20px",
                }}
              >
                <PhoneFilled />
                {telp}
              </p>
            ) : (
              <p />
            )}
          </p>
        </div>
        <div className="store-maps-location">
          <iframe
            title={mapTitle}
            src={mapSrc}
            style={{ width: "100%", border: "none" }}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export { LocationComponent, StoreLocationComponent };
